import React from 'react';
import { PdfComponent, PdfComponentType } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentName from './PdfTemplateComponentName';
import PdfTemplateComponentRepeat from './PdfTemplateComponentRepeat';
import PdfTemplateComponentSize from './PdfTemplateComponentSize';

export default function PdfTemplateComponentDefault({ component }: { component: PdfComponent }) {
  const { settings } = usePdfTemplateContext();

  return (
    <>
      <p className='section-title'>General</p>
      <PdfTemplateComponentName component={component} />
      <PdfTemplateComponentSize component={component} />
      {component.type !== PdfComponentType.table && !!settings.repeatModes.length && (
        <PdfTemplateComponentRepeat component={component} />
      )}
    </>
  );
}
